import { useLocation } from "react-router-dom"

const AddLabIndustrialApplication = () => {
  const location=useLocation()
  const {university_id,department_id,lab_id,group_id}=location?.state
  return (
    <div>
      Add Lab Industrial Application {university_id} {department_id} {lab_id} {group_id}
    </div>
  )
}

export default AddLabIndustrialApplication
